import React from 'react';
import Header from './Header';
import TestimonialCard from './TestimonialCard';
import CTAButton from './CTAButton';
import TimelineEvent from './TimelineEvent';
import FeaturePoint from './FeaturePoint';
import { CheckCircleIcon, BookOpenIcon, CalendarIcon } from 'lucide-react';
const Advertorial = () => {
  return <div className="max-w-4xl mx-auto bg-white shadow-md font-serif border border-gray-200" data-id="element-76" data-mp="12p7asg6ikj2j">
      <Header data-id="element-77" data-mp="1qdi3gw223cfq" />
      <main className="px-4 sm:px-8 py-8" data-id="element-78" data-mp="1qf1n8wmx85m9">
        <div className="prose max-w-none" data-id="element-79" data-mp="1vcus9mchmtky">
          <div className="flex items-center text-xs text-gray-500 mb-8 border-b border-gray-200 pb-2" data-id="element-80" data-mp="1vbs3pl2n1387">
            <div className="flex items-center mr-4" data-id="element-81" data-mp="1hca8onyr0tqe">
              <BookOpenIcon className="h-3 w-3 mr-1" data-id="element-82" data-mp="1mc4z6qem3hax" />
              <span data-id="element-83" data-mp="1mali4xl4t283">Health Investigation Series</span>
            </div>
            <div className="flex items-center" data-id="element-84" data-mp="5xn8gybvi5n5">
              <CalendarIcon className="h-3 w-3 mr-1" data-id="element-85" data-mp="5zzqtcljmi0q" />
              <span data-id="element-86" data-mp="ay17jqvhy591">
                Updated:{' '}
                {(() => {
                const yesterday = new Date();
                yesterday.setDate(yesterday.getDate() - 1);
                return yesterday.toLocaleDateString('en-US', {
                  month: 'long',
                  day: 'numeric',
                  year: 'numeric'
                });
              })()}
              </span>
            </div>
          </div>
          <p className="text-lg font-medium text-gray-700 mb-6 leading-relaxed border-l-4 border-gray-800 pl-4" data-id="element-87" data-mp="2ma93f3fkj6wo">
            In my three decades of medical practice, I've developed an absolute
            skepticism toward wellness trends that promise health results.
          </p>
          <div className="sm:flex sm:gap-8" data-id="element-88" data-mp="39wpgmkilz0d6">
            <div className="sm:w-2/3" data-id="element-89" data-mp="34xumimf6xpdr">
              <p className="mb-5 text-base" data-id="element-90" data-mp="34yw83ktu1u9q">
                Throughout the years, I've watched all of the "revolutionary"
                products take people's money while delivering nothing but false
                hope.
              </p>
              <p className="mb-5 text-base" data-id="element-91" data-mp="3m00eqx2uq7ap">
                So when patients began asking about grounding sheets a few years
                ago – those special bedsheets that supposedly connect you to the
                earth's electrical field – I was of course skeptical.
              </p>
              <p className="mb-5 text-base" data-id="element-92" data-mp="4ja65sb9pk3z">
                My advice was very simple: save your money for proven
                treatments.
              </p>
              <p className="mb-5 text-base" data-id="element-93" data-mp="8kca2mg4qkca">
                That position might have remained unchanged if not for a phone
                call from my sister Martha in February 2024.
              </p>
            </div>
            <div className="sm:w-1/3 bg-gray-50 p-5 rounded border border-gray-300 text-sm mt-6 sm:mt-0" data-id="element-94" data-mp="igyu590mt7d9">
              <div className="uppercase text-gray-600 text-xs font-sans tracking-wider mb-3 font-medium border-b border-gray-300 pb-2" data-id="element-95" data-mp="nfs5ausg4ma9">
                Key Points
              </div>
              <div className="space-y-3" data-id="element-96" data-mp="2pblpfw3kf5ao">
                <FeaturePoint data-id="element-97" data-mp="16ewq1d7l9j2c">
                  Most grounding sheets fail after 2-3 months due to oxidation
                </FeaturePoint>
                <FeaturePoint data-id="element-98" data-mp="11m3mutrrqisd">
                  Only one brand survived a full year of testing
                </FeaturePoint>
                <FeaturePoint data-id="element-99" data-mp="xjp03ykzayvt">
                  The patented technology prevents conductivity loss
                </FeaturePoint>
                <FeaturePoint data-id="element-100" data-mp="1pdr38hrembge">
                  Real-world testing showed significant sleep improvements
                </FeaturePoint>
              </div>
            </div>
          </div>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-101" data-mp="1gcatmc8eydd8">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-102" data-mp="1bcer6hfd6tzs"></span>
            My Sister's Sleep That Started My Investigation
          </h2>
          <div className="sm:flex items-center mb-6" data-id="element-103" data-mp="4v1dnzohu3go">
            <div className="sm:w-1/3 mb-4 sm:mb-0 sm:mr-6" data-id="element-104" data-mp="3w2xdxyqrjbc7">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3dvnTq6PjH596tKqQSVLgR/IMG2.png" alt="Woman with Fitbit reading in bed" className="w-full rounded-lg shadow-md" data-id="element-105" data-mp="1nv8z7c2eziup" />
            </div>
            <div className="sm:w-2/3" data-id="element-106" data-mp="1es7u9epabxsm">
              <p className="mb-5 text-base" data-id="element-107" data-mp="1jsvtuorkxmyg">
                My 68 year old sister, Martha, has dealt with rheumatoid
                arthritis for fifteen years. She's the type who tries everything
                but believes nothing – exactly how I raised her to be.
              </p>
              <p className="mb-5 text-base" data-id="element-108" data-mp="1xl2aebyn9vyf">
                When she called about her new grounding sheet, I was ready with
                my usual "gentle sister reality check" about placebo effects.
              </p>
              <p className="mb-5 text-base" data-id="element-109" data-mp="m5dm9h9nmqw1">
                "I'm sending you my FitBit data, look at it before you lecture
                me," she said.
              </p>
            </div>
          </div>
          <div className="my-8" data-id="element-110" data-mp="jk5wca2hktiz">
            <div className="border-l-4 border-yellow-400 pl-5 py-4 bg-yellow-50 rounded-r mb-4" data-id="element-111" data-mp="jje1j1gpqztr">
              <p className="font-medium mb-3 text-gray-800" data-id="element-112" data-mp="eluo23ruar2v">
                Before grounding sheet:
              </p>
              <p className="mb-0 text-gray-700" data-id="element-113" data-mp="sjj673uivk48">
                Sleep score 67-71, deep sleep 42 minutes, waking up 8-12 times
              </p>
            </div>
            <div className="border-l-4 border-green-500 pl-5 py-4 bg-green-50 rounded-r" data-id="element-114" data-mp="3w3f4t7xxzh6e">
              <p className="font-medium mb-3 text-gray-800" data-id="element-115" data-mp="3s2bsgvf3s39x">
                Two weeks with sheet:
              </p>
              <p className="mb-0 text-green-700" data-id="element-116" data-mp="9om5i22s4l13">
                Sleep score 84-87, deep sleep 1 hour 48 minutes, waking up 2-3
                times
              </p>
            </div>
          </div>
          <p className="mb-5 text-base" data-id="element-117" data-mp="3dabb5mkq54bs">
            "Patricia, I slept seven hours straight. That hasn't happened since
            Obama was president."
          </p>
          <p className="mb-5 text-base" data-id="element-118" data-mp="1c8vb1zj22jl4">
            Martha doesn't exaggerate. These weren't subtle changes – they were
            dramatic and sustained.
          </p>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-119" data-mp="1lzycj2fwd0kx">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-120" data-mp="1qxrhxt9dlqk5"></span>
            The Voltage Test Of My Sister's Sheets
          </h2>
          <div className="sm:flex items-center mb-6" data-id="element-121" data-mp="td59gdf1bp7r">
            <div className="sm:w-1/2 mb-4 sm:mb-0 sm:mr-6" data-id="element-122" data-mp="yb6peph5z8f0">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/693yUBGTdmCkkbmeDXBSis/IMG3.png" alt="Multimeter testing showing 0.20 volts" className="w-full rounded-lg shadow-md" data-id="element-123" data-mp="13987p86rn3pf" />
            </div>
            <div className="sm:w-1/2" data-id="element-124" data-mp="2eo3yttmlmxmv">
              <p className="mb-5 text-base" data-id="element-125" data-mp="2ipp7f2s3opr9">
                I showed up at Martha's with my equipment to prove this was
                psychological.
              </p>
              <div className="border border-yellow-400 p-5 my-4 bg-yellow-50 rounded" data-id="element-126" data-mp="74pyipk7xo7n">
                <p className="mb-3 text-base" data-id="element-127" data-mp="31tnbjx0cudq">
                  Her body voltage on a regular mattress:{' '}
                  <span className="font-bold" data-id="element-128" data-mp="3udl9qodf2x7q">3.8 volts</span> (normal).
                </p>
                <p className="text-base" data-id="element-129" data-mp="3pgctitbtx394">
                  On the grounding sheet:{' '}
                  <span className="font-bold" data-id="element-130" data-mp="3kitdpozhgif2">0.20 volts</span>.
                </p>
              </div>
              <p className="mb-5 text-base" data-id="element-131" data-mp="3fh3z5zd1xmm8">
                I tested it four more times. The sheet had eliminated 99% of her
                body's electrical charge.
              </p>
              <p className="mb-0 text-base" data-id="element-132" data-mp="36jbjuv7byeyu">
                This was measurable physics, not psychology.
              </p>
            </div>
          </div>
          <h3 className="text-xl font-serif font-bold text-gray-800 mt-8 mb-4" data-id="element-133" data-mp="14qnf2hf1fjgy">
            Studies I Couldn't Ignore
          </h3>
          <p className="mb-5 text-base" data-id="element-134" data-mp="dmcmkoudxf4s">That night I found:</p>
          <div className="border-l-4 border-blue-400 pl-5 py-4 bg-blue-50 rounded-r mb-5" data-id="element-135" data-mp="ijuxgkryq4ff">
            <p className="mb-2 text-base" data-id="element-136" data-mp="3v8bi07tyef8">
              <strong data-id="element-137" data-mp="3uf91bfwmb2w">Journal of Environmental and Public Health:</strong>{' '}
              Grounding reduces blood viscosity almost as effectively as aspirin
            </p>
            <p className="mb-2 text-base" data-id="element-138" data-mp="3qzel949v6un3">
              <strong data-id="element-139" data-mp="3qymss2bkdd11">European Biology and Bioelectromagnetics:</strong> 50%
              reduction in inflammatory markers after grounding
            </p>
            <p className="mb-2 text-base" data-id="element-140" data-mp="3h2jqmwgppee3">
              <strong data-id="element-141" data-mp="3h3l0ixlzruu8">Journal of Inflammation Research:</strong> Normalized
              cortisol patterns and improved sleep architecture
            </p>
            <p className="mb-2 text-base" data-id="element-142" data-mp="1fa3xk78t3i5t">
              <strong data-id="element-143" data-mp="1fb6lc6au14hi">
                Journal of Alternative and Complementary Medicine:
              </strong>{' '}
              Thermal imaging showing improved circulation
            </p>
          </div>
          <p className="mb-5 text-base" data-id="element-144" data-mp="34pemsar5iaym">
            Twenty-seven peer-reviewed studies, with real science, all written
            in legitimate journals.
          </p>
          <p className="mb-6 text-base" data-id="element-145" data-mp="3ei3ucujkz4oo">
            But what really bothered me: These studies were using real
            laboratory-grade grounding equipment, not something you can get on
            Amazon for 60$.
          </p>
          <p className="mb-5 text-base" data-id="element-146" data-mp="3nk3azlqoo6r3">So I wanted to know:</p>
          <p className="mb-5 text-base" data-id="element-147" data-mp="3ii480cyuvbuo">
            Were consumer sheets actually providing therapeutic grounding? Or
            was this another case of real science being exploited by garbage
            products?
          </p>
          <p className="mb-6 text-base" data-id="element-148" data-mp="3sf0i2n4ek61c">I had to know.</p>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-149" data-mp="2336qwfmngcxs">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-150" data-mp="1y4wvq50xdcc6"></span>
            The 6-Month Investigation Begins
          </h2>
          <div className="sm:flex items-center mb-6" data-id="element-151" data-mp="hy8dlw8ht9md">
            <div className="sm:w-1/2 mb-4 sm:mb-0 sm:mr-6" data-id="element-152" data-mp="hwdtgk51pljc">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/dHo5VEQhYCbAaMWfhatkAv/IMG5.png" alt="Boxes of grounding sheets" className="w-full rounded-lg shadow-md" data-id="element-153" data-mp="cy2gi0jgeuww" />
            </div>
            <div className="sm:w-1/2" data-id="element-154" data-mp="15pm8a8u49hai">
              <p className="mb-5 text-base" data-id="element-155" data-mp="10o6jq6sqcsnd">
                I bought 12 grounding sheets ($89-$249) and recruited 12
                volunteers with chronic pain or insomnia, ages 52-74.
              </p>
              <div className="border border-gray-300 p-5 my-4 bg-gray-50 rounded" data-id="element-156" data-mp="qzevo9qsishq">
                <p className="font-medium mb-3 text-gray-800 border-b border-gray-300 pb-2" data-id="element-157" data-mp="1oekfa7aix9mp">
                  What I measured:
                </p>
                <div className="space-y-3" data-id="element-158" data-mp="1jlzn1a79n4la">
                  <FeaturePoint data-id="element-159" data-mp="1rw83zt097pr0">Body voltage</FeaturePoint>
                  <FeaturePoint data-id="element-160" data-mp="1rxrjhhe35wrq">Sleep quality</FeaturePoint>
                  <FeaturePoint data-id="element-161" data-mp="1vws3324e13fs">Pain levels (daily logs)</FeaturePoint>
                  <FeaturePoint data-id="element-162" data-mp="20wwieotk7s4f">
                    Inflammation markers (CRP blood tests)
                  </FeaturePoint>
                  <FeaturePoint data-id="element-163" data-mp="25vzmo71ptubc">
                    Sheet conductivity (weekly multimeter tests)
                  </FeaturePoint>
                </div>
              </div>
            </div>
          </div>
          <p className="mb-6 text-base" data-id="element-164" data-mp="2evcnycforckz">
            The plan was to test everything for six months and let the data
            speak.
          </p>
          <div className="mt-12 mb-10" data-id="element-165" data-mp="2jpgvoxwrzon4">
            <h2 className="text-2xl font-serif font-bold text-gray-800 mb-8 border-b border-gray-800 pb-2 flex items-center" data-id="element-166" data-mp="2omh259xjeter">
              <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-167" data-mp="2tmvcwzqiwhgh"></span>
              The Investigation Timeline
            </h2>
            <TimelineEvent title="Week 1: Every Single Sheet Worked" data-id="element-168" data-mp="2yi0u5l8zd7y8">
              <p className="mb-4 text-base" data-id="element-169" data-mp="28wriespdfagt">
                I'm not going to lie – the first week shook me.
              </p>
              <p className="mb-4 text-base" data-id="element-170" data-mp="23vbu8rrwcnu7">
                All twelve sheets worked immediately.
              </p>
              <div className="bg-green-50 border-l-4 border-green-500 p-4 my-4 rounded-r" data-id="element-171" data-mp="2dvm6oa63xr8b">
                <p className="text-base" data-id="element-172" data-mp="2rmqywr75bh8m">
                  Body voltage dropped 99%, sleep scores improved 15-20 points,
                  pain decreased.
                </p>
                <p className="mt-3 text-base" data-id="element-173" data-mp="2mpqs2e2h2agg">
                  Even my 30-year-old back pain improved.
                </p>
              </div>
              <p className="mb-0 text-base" data-id="element-174" data-mp="2wlakurlqot0z">
                By day 7, I had to accept it: Grounding is absolutely real. The
                science is legitimate. The benefits are measurable. To be fair,
                I've absolutely enjoyed the experiment so far.
              </p>
            </TimelineEvent>
            <TimelineEvent title="Month 2: The Decline" data-id="element-175" data-mp="3dw7i6brlfqmr">
              <p className="mb-4 text-base" data-id="element-176" data-mp="3iu9cjsugzcdj">
                Around week 8, the complaints started rolling in:
              </p>
              <p className="mb-4 italic text-gray-700 text-base" data-id="element-177" data-mp="3464t2mnlewtp">
                "I'm not sleeping as well as I was" "My hip pain is coming back"
                "Maybe my body got used to it?"
              </p>
              <div className="sm:flex items-center mb-4" data-id="element-178" data-mp="2v3lony45sc5c">
                <div className="sm:w-1/2 mb-4 sm:mb-0 sm:mr-6" data-id="element-179" data-mp="2z6a26j3ti78n">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/nyq3vwxuQy7oNgMzR466vs/IMG6.png" alt="Failed grounding sheets in laundry basket" className="w-full rounded-lg shadow-md" data-id="element-180" data-mp="2z7l40ddpd4x4" />
                </div>
                <div className="sm:w-1/2" data-id="element-181" data-mp="jfx90ni91mgy">
                  <p className="mb-4 text-base" data-id="element-182" data-mp="odyqx53xvfqu">
                    I tested everyone's sheets with my multimeter and what I
                    found explained everything:
                  </p>
                  <div className="border border-gray-400 p-4 my-4 bg-gray-50 rounded" data-id="element-183" data-mp="2fiigyi0296au">
                    <p className="mb-3 text-base" data-id="element-184" data-mp="2bgnhlj1ox2zp">
                      <strong data-id="element-185" data-mp="2bfcc9esljn6h">Week 1 readings:</strong> 15-45 ohms (excellent
                      conductivity)
                    </p>
                    <p className="text-base" data-id="element-186" data-mp="26jx14ulz45dr">
                      <strong data-id="element-187" data-mp="21jj4e8ptohv1">Week 8 readings:</strong> 400-2,000+ ohms (failing
                      or dead)
                    </p>
                  </div>
                </div>
              </div>
              <p className="mb-0 text-base" data-id="element-188" data-mp="1rrwhhf44gucg">
                Five sheets had already died! The volunteers were sleeping on
                expensive regular cotton that no longer conducted anything.
              </p>
              <p className="mb-0 text-base" data-id="element-189" data-mp="1iqop1doaenqa">
                The silver threads were oxidizing – reacting with sweat, oxygen,
                and detergent, basically dying off after a month.
              </p>
            </TimelineEvent>
            <TimelineEvent title="Month 3: Mass Failure" data-id="element-190" data-mp="3pimjtl3sdtrd">
              <p className="mb-4 text-base" data-id="element-191" data-mp="3ue1vc6ebndkm">
                Most sheets were dead – over 1,000 ohms (the conducting fully
                stopped).
              </p>
              <p className="mb-0 text-base bg-yellow-100 p-2 inline-block" data-id="element-192" data-mp="7b5k1sn1y7jx">
                I thought my research will be shortly over: Do brands charge
                people hundreds of $$$ for sheets that last twelve weeks? This
                is ridiculous
              </p>
            </TimelineEvent>
            <TimelineEvent title="Month 6: Three Survivors Emerge" data-id="element-193" data-mp="3fq73es851d8l">
              <p className="mb-4 text-base" data-id="element-194" data-mp="3kh5lnxcosleh">
                After six months of daily use and weekly washing, only three
                sheets were still functioning:
              </p>
              <div className="border border-yellow-400 p-4 my-4 bg-yellow-50 rounded" data-id="element-195" data-mp="2nx6lh6cg03jg">
                <p className="mb-2 text-base" data-id="element-196" data-mp="2rz1r2n1ep331">
                  <strong data-id="element-197" data-mp="3vb8nybwvykoj">BareEarth</strong> – 31 ohms (started at 24)
                </p>
                <p className="mb-2 text-base" data-id="element-198" data-mp="3qcyrzz3c7g1v">
                  <strong data-id="element-199" data-mp="3qc5uzpu6k4wx">GroundingWell</strong> – 67 ohms (started at 35)
                </p>
                <p className="mb-2 text-base" data-id="element-200" data-mp="8uw77c4bz7fv">
                  <strong data-id="element-201" data-mp="3x4g2kbifpcq">Earthing.com</strong> – 89 ohms (started at 41)
                </p>
                <p className="mt-4 mb-2 text-base border-t border-yellow-300 pt-2" data-id="element-202" data-mp="3ccwfksdsteu0">
                  <strong data-id="element-203" data-mp="3cf0jhabp6dua">Nine sheets:</strong> Completely dead (over 1,000
                  ohms)
                </p>
                <p className="text-base" data-id="element-204" data-mp="3ldm9fqji0v53">
                  <strong data-id="element-205" data-mp="3ledsy2ztn2f0">Three sheets:</strong> Still grounding effectively
                </p>
              </div>
            </TimelineEvent>
            <TimelineEvent title="Month 12: The Winners" data-id="element-206" data-mp="3hedggnwa91al">
              <p className="mb-4 text-base" data-id="element-207" data-mp="10m27ptnyr75o">Month 12 results:</p>
              <div className="border border-yellow-400 p-4 my-4 bg-yellow-50 rounded" data-id="element-208" data-mp="wm1s45p4opx1">
                <p className="mb-2 text-base font-bold text-green-700" data-id="element-209" data-mp="145atpcre7kbj">
                  <strong data-id="element-210" data-mp="147dt2nefqpsx">BareEarth:</strong> 34 ohms – STILL PERFECT
                </p>
                <p className="mb-2 text-base" data-id="element-211" data-mp="195p2ix0tiyam">
                  <strong data-id="element-212" data-mp="u7d86x0x41mm">GroundingWell:</strong> 287 ohms (marginal)
                </p>
                <p className="mb-2 text-base" data-id="element-213" data-mp="z67vab5x4ccj">
                  <strong data-id="element-214" data-mp="z6zjv213l9tb">Earthing.com:</strong> 419 ohms (barely functional)
                </p>
              </div>
              <p className="mb-3 text-base" data-id="element-215" data-mp="1mwke4h2pbthw">12 months.</p>
              <p className="mb-3 text-base" data-id="element-216" data-mp="1rv53flgf0srk">
                After daily use and weekly washing with regular detergent, this
                one sheet was conducting electricity as well as the day I bought
                it.
              </p>
              <p className="mb-0 text-base" data-id="element-217" data-mp="1i3982i5prgr1">
                How was this possible? I needed to know
              </p>
            </TimelineEvent>
          </div>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-218" data-mp="2almxpugwbwf1">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-219" data-mp="akevo2fok09l"></span>
            Tracking Down the Mystery
          </h2>
          <p className="mb-5 text-base" data-id="element-220" data-mp="5qkhfeiugdhw">
            BareEarth was a company I'd never heard of.
          </p>
          <p className="mb-5 text-base" data-id="element-221" data-mp="3sxd0onrbxjam">
            Small operation out of Louisville, Kentucky.
          </p>
          <p className="mb-5 text-base" data-id="element-222" data-mp="tihoytf9gjd7">
            Their website was basic, their marketing minimal.
          </p>
          <p className="mb-5 text-base" data-id="element-223" data-mp="phfo685p3z94">
            Yet their sheets outlasted brands charging twice as much.
          </p>
          <div className="sm:flex items-center mb-6" data-id="element-224" data-mp="kfqeowy4ftn5">
            <div className="sm:w-1/2 mb-4 sm:mb-0 sm:mr-6" data-id="element-225" data-mp="fiq6oghpogte">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/w6iLitytwoh7neSkFUSQgw/IMG7.png" alt="Email from Patricia to Tom Davidson" className="w-full rounded-lg shadow-md" data-id="element-226" data-mp="fkaza0kgtpom" />
            </div>
            <div className="sm:w-1/2" data-id="element-227" data-mp="2q5ton8wnc3jq">
              <p className="mb-5 text-base" data-id="element-228" data-mp="2q2o1hz7kvbqn">
                I found the founder's email right on their website and offered
                him a call.
              </p>
              <p className="mb-5 text-base" data-id="element-229" data-mp="3013vqb1wj14d">Two hours later, my phone rang.</p>
              <p className="italic text-gray-700 text-base border-l-2 border-gray-400 pl-3" data-id="element-230" data-mp="34uge43fzmboo">
                "Patricia? This is Tom Davidson. I've been waiting three years
                for someone in medicine to ask these questions."
              </p>
            </div>
          </div>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-231" data-mp="3iswnk258igai">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-232" data-mp="3nrr4sznjzwsi"></span>
            The 72-Year Old Retired Engineer That Solved The Problem
          </h2>
          <div className="sm:flex items-center mb-6" data-id="element-233" data-mp="1tdq5yes079sf">
            <div className="sm:w-1/2 mb-4 sm:mb-0 sm:mr-6" data-id="element-234" data-mp="1tgccqc72ll9l">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/gVogzxobjei3H7teaskxTv/IMG8.png" alt="Tom Davidson in his workshop" className="w-full rounded-lg shadow-md" data-id="element-235" data-mp="1dx96mbap88w" />
            </div>
            <div className="sm:w-1/2" data-id="element-236" data-mp="f4aj2u7qyx0v">
              <p className="mb-5 text-base" data-id="element-237" data-mp="f5c3vqekexvs">
                Tom Davidson wasn't what I expected. A 72-year-old retired
                electrical engineer from Corning, the company that makes Gorilla
                Glass and fiber optic cables. He said he stumbled into grounding
                through his chronic hip pain.
              </p>
              <div className="border-l-4 border-gray-300 pl-5 py-4 bg-gray-50 rounded-r" data-id="element-238" data-mp="t28wnxe8upfb">
                <p className="mb-5 text-base" data-id="element-239" data-mp="y127tj6264cb">
                  "I loved grounding sheets," he told me. "They helped my pain,
                  improved my sleep. But they kept dying after three months. I
                  was spending $600 a year on sheets that would crap out."
                </p>
                <p className="mb-0 text-base" data-id="element-240" data-mp="2sd3as3cqjgnd">
                  "That's exactly what I found," I said.
                </p>
              </div>
            </div>
          </div>
          <p className="mb-0 text-base bg-yellow-100 p-2 inline-block" data-id="element-241" data-mp="2ilqk3f2oawix">
            "Right. So I did what engineers do – I solved the problem."
          </p>
          <p className="mb-6 text-base" data-id="element-242" data-mp="3baecrvpr4o6i">
            His solution came from an unexpected place.
          </p>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-243" data-mp="36ai8rwh20wqy">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-244" data-mp="31a3y06o2j8p8"></span>
            The "Immortal" Submarine Cables
          </h2>
          <div className="sm:flex items-center mb-6" data-id="element-245" data-mp="1pwjnwmqoyj0u">
            <div className="sm:w-1/2 mb-4 sm:mb-0 sm:mr-6" data-id="element-246" data-mp="1pxb871eu8ubt">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8YpH7vXuQJk3PcMuCb4bB2/IMG9.webp" alt="Submarine cables on the ocean floor" className="w-full rounded-lg shadow-md" data-id="element-247" data-mp="1lv6k0i75spwk" />
            </div>
            <div className="sm:w-1/2" data-id="element-248" data-mp="1s93wiseob60y">
              <p className="mb-5 text-base" data-id="element-249" data-mp="1depd4qr75ulr">
                "You know those cables at the bottom of the ocean? The ones
                carrying internet data between continents?"
              </p>
              <p className="mb-5 text-base" data-id="element-250" data-mp="14lcc11izbmol">"Vaguely," I admitted.</p>
              <div className="border-l-4 border-blue-300 pl-5 py-4 bg-blue-50 rounded-r" data-id="element-251" data-mp="19cc7s3gd3ypi">
                <p className="mb-5 text-base" data-id="element-252" data-mp="19e5hxsq6p129">
                  "They work for 25+ years at the bottom of the ocean and never
                  fail. If we can keep cables working at the bottom of the
                  Pacific for decades, why can't we keep a bed sheet working for
                  more than three months?"
                </p>
              </div>
            </div>
          </div>
          <div className="border-l-4 border-blue-300 pl-5 py-4 my-6 bg-blue-50 rounded-r" data-id="element-253" data-mp="pq658cc27ju7">
            <p className="mb-5 text-base" data-id="element-254" data-mp="725fq3v0ujf3">
              "How DO submarine cables stay conductive?" I asked.
            </p>
            <p className="mb-0 text-base" data-id="element-255" data-mp="g0hdqqy7wjhk">
              "Hermetic shielding. Multiple protective layers. The outer layer
              takes all the damage – oxidation, corrosion, degradation – while
              the inner core stays perfect. It's like having sacrificial armor."
            </p>
          </div>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-256" data-mp="l0c66yxn5h4q">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-257" data-mp="ypxhro942u2q"></span>
            The Triple-Shield Threading Innovation
          </h2>
          <div className="sm:flex items-center mb-6" data-id="element-258" data-mp="urzrsj7io3ya">
            <div className="sm:w-1/2 mb-4 sm:mb-0 sm:mr-6" data-id="element-259" data-mp="18q6fx7mnypkr">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/xgP6i5wfhJpSrhNgg4aT5L/IMG10.png" alt="Triple-shield technology diagram showing layers" className="w-full rounded-lg shadow-md" data-id="element-260" data-mp="13qk492mhhhe2" />
            </div>
            <div className="sm:w-1/2" data-id="element-261" data-mp="1rrnfvvg6jim7">
              <p className="mb-5 text-base" data-id="element-262" data-mp="1wkgmkov7l10x">
                Tom explained what makes them different:
              </p>
              <p className="mb-5 text-base" data-id="element-263" data-mp="21ii598oq2ybv">
                "We developed Triple-Shield Threading. Each silver thread has
                three distinct layers:
              </p>
              <div className="bg-blue-50 border-l-4 border-blue-500 p-5 rounded-r" data-id="element-264" data-mp="18w72pshk2ncf">
                <div className="space-y-3" data-id="element-265" data-mp="1dtpdlof4vcn2">
                  <FeaturePoint data-id="element-266" data-mp="1dsxgua9sv8v7">
                    <strong data-id="element-267" data-mp="1itbs016p6yxg">Outer shield</strong> – Takes all the oxidation
                    damage
                  </FeaturePoint>
                  <FeaturePoint data-id="element-268" data-mp="2p8ce7f5x82qu">
                    <strong data-id="element-269" data-mp="2p95q0ujqlifu">Middle layer</strong> – Secondary protection
                  </FeaturePoint>
                  <FeaturePoint data-id="element-270" data-mp="2ualaoli05mxp">
                    <strong data-id="element-271" data-mp="ikvk38yqman5">Conductive core</strong> – Never exposed, stays
                    untouched
                  </FeaturePoint>
                </div>
              </div>
            </div>
          </div>
          <p className="mb-5 text-base" data-id="element-272" data-mp="8utsw8b38c40">
            "Even if the outer layer completely oxidizes, you still have two
            functional layers maintaining conductivity."
          </p>
          <p className="mb-5 text-base" data-id="element-273" data-mp="3vzry8n6pyq25">
            "Like Russian nesting dolls," I said.
          </p>
          <p className="mb-6 text-base bg-yellow-100 p-2" data-id="element-274" data-mp="3r0fb01bxrgz1">
            "Exactly! The weaving has 47 twists per inch, forming a natural
            spiral that makes it strong and reliable. Even if 70% of the silver
            on the outside gets oxidized, the inner cores stay protected and
            keep the current flowing normally."
          </p>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-275" data-mp="1k9phon3g7tya">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-276" data-mp="39rw7ynsxtrjr"></span>
            The $388,176 Investment
          </h2>
          <p className="mb-5 text-base" data-id="element-277" data-mp="3eima7s62hea8">
            "This sounds expensive to manufacture," I said.
          </p>
          <div className="sm:flex items-center mb-6" data-id="element-278" data-mp="2zuriadzvvdy7">
            <div className="sm:w-1/2 mb-4 sm:mb-0 sm:mr-6" data-id="element-279" data-mp="34sjcxfrwxe63">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qBYMNDjFnaijkL2KMBjNc2/IMG11.png" alt="Industrial looms for manufacturing triple-shield threading" className="w-full rounded-lg shadow-md" data-id="element-280" data-mp="34st1cyxb7d9o" />
            </div>
            <div className="sm:w-1/2" data-id="element-281" data-mp="3jgw84aj6eszj">
              <div className="border-l-4 border-gray-300 pl-5 py-4 bg-gray-50 rounded-r" data-id="element-282" data-mp="3nj0y8zaf17hf">
                <p className="mb-5 text-base" data-id="element-283" data-mp="3nkvn2oot5jqs">
                  Tom laughed. "My ex-colleagues from Corning and I pooled our
                  retirement funds. About $400,000 total. We had to buy looms
                  that could handle triple-layer weaving without destroying the
                  threads, you can't find them on the street!"
                </p>
                <p className="mb-5 text-base" data-id="element-284" data-mp="1zkqffv1p54pi">
                  "Your wife must have loved that."
                </p>
                <p className="mb-0 text-base" data-id="element-285" data-mp="2egg5q5dx0401">
                  "She threatened divorce... But here's the thing – I showed our
                  technology to three major manufacturers, wanna know what they
                  said?"
                </p>
              </div>
            </div>
          </div>
          <p className="mb-5 text-base" data-id="element-286" data-mp="1gsnzklwvpsgb">"What?"</p>
          <p className="mb-6 text-base bg-yellow-100 p-2" data-id="element-287" data-mp="1vkq3ch22l5lm">
            "'Why would we want sheets that last 10 years when customers reorder
            every four months?' They literally told me their business model
            depends on sheets failing."
          </p>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-288" data-mp="y4iwzhrykdj3">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-289" data-mp="clzjtgx86vtk"></span>
            And Yes It's Patented
          </h2>
          <p className="mb-5 text-base" data-id="element-290" data-mp="hkkjnf8kfdhh">
            "Can't they just copy your technology?"
          </p>
          <p className="mb-6 text-base bg-yellow-100 p-2" data-id="element-291" data-mp="mhu92uvyfp5b">
            "Patent #US10,847,293. It took me two years to get approved, but now
            it's mine. They couldn't copy it if they wanted to."
          </p>
          <p className="mb-6 text-base" data-id="element-292" data-mp="vhze4ydoebgb">"Which they don't."</p>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-293" data-mp="10hc25mga9okh">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-294" data-mp="15bzhovtb78mx"></span>
            The Three-Year Test Sheet
          </h2>
          <div className="sm:flex items-center mb-6" data-id="element-295" data-mp="1eatlp78yz1ai">
            <div className="sm:w-1/2 mb-4 sm:mb-0 sm:mr-6" data-id="element-296" data-mp="1ec4ob3qoi301">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/caiVyDzajd3WGvCdTW9Fxa/IMG12.png" alt="Tom Davidson holding a grounding sheet and plug" className="w-full rounded-lg shadow-md" data-id="element-297" data-mp="1j8mn7mzbv74g" />
            </div>
            <div className="sm:w-1/2" data-id="element-298" data-mp="2uq8twpb2v4vd">
              <p className="mb-5 text-base" data-id="element-299" data-mp="2urahtud6zlui">
                "Tom, do you have proof this lasts as long as you claim?"
              </p>
              <p className="mb-5 text-base" data-id="element-300" data-mp="2pu0gphgfxlqu">"Hold on."</p>
              <p className="mb-5 text-base" data-id="element-301" data-mp="3mgn52drpi33c">
                He returned to the video call with a grounding sheet.
              </p>
              <p className="mb-5 text-base" data-id="element-302" data-mp="3iipd536jx2w9">
                "This is our first prototype, we made it three years ago. My
                cousin used it every single night and washed twice weekly."
              </p>
              <p className="mb-5 text-base" data-id="element-303" data-mp="a0jiyndhw37y">He connected his multimeter.</p>
              <p className="mb-5 text-base" data-id="element-304" data-mp="a2mh5uosx2nr">
                The reading:{' '}
                <span className="font-bold text-green-700" data-id="element-305" data-mp="588jflmo2jfx">68 ohms.</span>
              </p>
            </div>
          </div>
          <p className="mb-5 text-base" data-id="element-306" data-mp="3tastbzj16rel">
            After three years of use and roughly 300 washes.
          </p>
          <p className="mb-5 text-base bg-yellow-100 p-2" data-id="element-307" data-mp="71rgxgtl5ya1">
            My sheets that died after three months read over 2,000 ohms.
          </p>
          <p className="mb-5 text-base" data-id="element-308" data-mp="21wubpgufuus">"This is incredible," I said.</p>
          <p className="mb-6 text-base" data-id="element-309" data-mp="g1xwd88uh8bu">
            "This is just proper engineering," he replied.
          </p>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-310" data-mp="bzt3wcu4uhqs">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-311" data-mp="prhay1piyg0w"></span>
            Gift From Tom That Won My Heart
          </h2>
          <div className="sm:flex items-center mb-6" data-id="element-312" data-mp="zq6x46ogemmy">
            <div className="sm:w-1/2 mb-4 sm:mb-0 sm:mr-6" data-id="element-313" data-mp="zqyf2ep4olur">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/h3pU8oFUQasAmK4qhT6W3E/IMG13.png" alt="Email from Tom offering special pricing" className="w-full rounded-lg shadow-md" data-id="element-314" data-mp="urvk5n2v3w0i" />
            </div>
            <div className="sm:w-1/2" data-id="element-315" data-mp="14ey8dl0uj30q">
              <p className="mb-5 text-base" data-id="element-316" data-mp="14dwkgfyqem1l">
                Two weeks after our call, Tom sent an email that surprised me:
              </p>
              <p className="mb-5 text-base" data-id="element-317" data-mp="19g5ezgr95w5t">I called him immediately.</p>
              <p className="mb-5 text-base" data-id="element-318" data-mp="unlfcq3ba6t4">
                "Tom, you can't be serious about selling at cost."
              </p>
              <p className="mb-5 text-base bg-yellow-100 p-2" data-id="element-319" data-mp="zhpnvds86mwb">
                "Patricia, these companies are stealing from people. If your
                article helps people find sheets that actually work AND saves
                them money? That will be worth more than profit to me. Once
                people test these sheets and see they're still working after a
                year, word spreads. This is marketing, just the honest kind."
              </p>
            </div>
          </div>
          <div className="border-t border-b border-gray-300 py-8 my-12 bg-gray-50" data-id="element-320" data-mp="3trzbekieyzc1">
            <h3 className="text-xl font-medium text-gray-800 mb-5 text-center border-b border-gray-300 pb-3" data-id="element-321" data-mp="3oy4q5cn5ucau">
              Get Our Sheets at Production Cost - $109.90
            </h3>
            <CTAButton url="https://offer.bareearthlife.com/groundedsheets/v719/checkout-med?uid=4027&oid=858&affid=719" data-id="element-322" data-mp="3f2tfb5evhp8d" />
            <div className="text-xs text-gray-500 mt-3 text-center" data-id="element-323" data-mp="ghjoyi0rsnia">
              Limited to current inventory of 278 sheets
            </div>
          </div>
          <p className="mb-6 text-base" data-id="element-324" data-mp="6kf02afjidxs">
            I reached out to BareEarth customers to verify longevity:
          </p>
          <div className="my-8" data-id="element-325" data-mp="1m3uwd06wrlw">
            <TestimonialCard name="Jennifer K." location="Austin, Texas" duration="2 years" testimonial="I used to buy new grounding sheets every 3-4 months. This ONE sheet has outlasted seven previous ones combined. My sleep scores have been consistent for two years straight." data-id="element-326" data-mp="2rbfkmst91hk8" />
            <TestimonialCard name="Robert M." location="Phoenix" duration="18 months" testimonial="Chronic back pain from construction work. This one bed sheet still works perfectly after 18 months. I know Tom personally, never had a doubt it will be great." data-id="element-327" data-mp="16u6e394f4m2d" />
            <TestimonialCard name="Maria S., RN" location="San Diego" duration="14 months" testimonial="As a nurse, I test everything. Other sheets die by month 3. My BareEarth conducts after 14 months of 12-hour shifts and stress sweats just as well as it used to when I bought it." data-id="element-328" data-mp="1lkvs0j99kf9x" />
          </div>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-329" data-mp="6rcdkhc3yxi">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-330" data-mp="5649qz5u0oec"></span>
            The Safety Question Everyone Asks
          </h2>
          <p className="mb-5 text-base" data-id="element-331" data-mp="1qmtoljo794z2">
            "But is it safe to be plugged into the wall?"
          </p>
          <p className="mb-5 text-base" data-id="element-332" data-mp="24l1p21kg2oez">
            This was everyone's first concern, including mine.
          </p>
          <p className="mb-5 text-base" data-id="element-333" data-mp="20kzmlq6vxqyn">
            Here's what three electrical engineers confirmed:
          </p>
          <div className="border border-yellow-400 p-5 my-8 bg-yellow-50 rounded" data-id="element-334" data-mp="1cv5e1ktlmok7">
            <h3 className="text-lg font-medium mb-4 text-gray-800" data-id="element-335" data-mp="17xdlcol4qyey">
              Safety Assessment:
            </h3>
            <p className="mb-4 text-base text-gray-700" data-id="element-336" data-mp="1lpbl48sybhyg">
              You're ONLY connected to the ground pin – the round hole at the
              bottom of your outlet. This pin carries ZERO electricity. Its
              entire purpose is safety discharge.
            </p>
            <p className="text-gray-700 mb-5 text-base" data-id="element-337" data-mp="p4t6ib29mtu5">
              It's literally the same as standing barefoot on wet grass, just
              consistent and measurable.
            </p>
            <p className="text-gray-800 font-medium mb-3" data-id="element-338" data-mp="jsw32bbqm1tk">
              In 12 months of testing with multiple users:
            </p>
            <div className="space-y-2" data-id="element-339" data-mp="513s0biz79xn">
              <div className="flex items-center text-gray-700" data-id="element-340" data-mp="a1hyvq8ucdu3">
                <CheckCircleIcon className="h-5 w-5 text-green-600 mr-2 flex-shrink-0" data-id="element-341" data-mp="9zyfhqrw1mo3" />
                <span className="text-base" data-id="element-342" data-mp="xpsr650h156r">Zero electrical incidents</span>
              </div>
              <div className="flex items-center text-gray-700" data-id="element-343" data-mp="12ovyjw3xbnhw">
                <CheckCircleIcon className="h-5 w-5 text-green-600 mr-2 flex-shrink-0" data-id="element-344" data-mp="nso7qcy0fntn" />
                <span className="text-base" data-id="element-345" data-mp="srzlre6zsf7j">Zero shocks</span>
              </div>
              <div className="flex items-center text-gray-700" data-id="element-346" data-mp="38jf6ljxpj6g7">
                <CheckCircleIcon className="h-5 w-5 text-green-600 mr-2 flex-shrink-0" data-id="element-347" data-mp="38m1e5jklllyf" />
                <span className="text-base" data-id="element-348" data-mp="3dkba3we5cql3">Zero safety issues</span>
              </div>
            </div>
          </div>
          <p className="mb-6 text-base" data-id="element-349" data-mp="1k23z5taytlk4">
            The only "shocks" came from static buildup on the dead sheets –
            because they weren't actually grounding anything.
          </p>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-350" data-mp="1a84w8s32hxr4">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-351" data-mp="10ctiabzhgukf"></span>
            My Professional Verdict
          </h2>
          <p className="mb-5 text-base" data-id="element-352" data-mp="w9x550sppqnv">
            After 12 months of investigation, here's the truth:
          </p>
          <div className="space-y-3 mb-8 border border-yellow-400 p-5 bg-yellow-50 rounded" data-id="element-353" data-mp="rbvmui341vdg">
            <FeaturePoint data-id="element-354" data-mp="me3lkxgkswwl">
              Grounding is scientifically legitimate. The studies are real, the
              benefits measurable.
            </FeaturePoint>
            <FeaturePoint data-id="element-355" data-mp="2gqa8gtiu124q">
              Most grounding sheets are designed to fail. They die in 2-3 months
              from oxidation.
            </FeaturePoint>
            <FeaturePoint data-id="element-356" data-mp="2t95twsvfkb10">
              Only ONE brand survived a full year of testing while maintaining
              perfect conductivity.
            </FeaturePoint>
            <FeaturePoint data-id="element-357" data-mp="2y0nv9i1d8dmi">
              The technology exists to make sheets that last. But only one
              company is using it.
            </FeaturePoint>
            <FeaturePoint data-id="element-358" data-mp="25c079ep8fa59">
              The industry profits from failure. Repeat customers every 3 months
              is their business model.
            </FeaturePoint>
          </div>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-359" data-mp="2f8v1hleh2odq">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-360" data-mp="2k992wklkj02s"></span>
            The Opportunity Tom Created
          </h2>
          <div className="border border-gray-400 p-5 my-8 bg-gray-50 rounded" data-id="element-361" data-mp="3qqnub096qwhg">
            <p className="font-medium mb-4 text-gray-800" data-id="element-362" data-mp="3vm35fkft6ea6">
              Tom's offer for readers of this investigation:
            </p>
            <div className="space-y-2" data-id="element-363" data-mp="fn7vxywdsu0a">
              <div className="flex justify-between" data-id="element-364" data-mp="fo98k7t1pok4">
                <span className="text-base" data-id="element-365" data-mp="uc3xre7uhasg">Regular price:</span>
                <span className="text-base font-medium" data-id="element-366" data-mp="udowlg16zfw4">$219.98</span>
              </div>
              <div className="flex justify-between" data-id="element-367" data-mp="pkm0b0515sc8">
                <span className="text-base" data-id="element-368" data-mp="13cinqqvr7e2a">Investigation reader price:</span>
                <span className="font-bold text-green-700" data-id="element-369" data-mp="13emztw3t3jdn">$109.99</span>
              </div>
              <div className="flex justify-between" data-id="element-370" data-mp="zd9sfhl2f84m">
                <span className="text-base" data-id="element-371" data-mp="1d9x28ky49sry">Valid for:</span>
                <span className="text-base" data-id="element-372" data-mp="18bvjy28ilxhj">72 hours after publication</span>
              </div>
              <div className="flex justify-between" data-id="element-373" data-mp="3f2bhtdd6ul57">
                <span className="text-base" data-id="element-374" data-mp="3f34hxvhn6ced">Available inventory:</span>
                <span className="text-base" data-id="element-375" data-mp="3a3rsd2zdyr83">Approximately 200 sheets</span>
              </div>
            </div>
          </div>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-376" data-mp="1pmim7kegvxqr">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-377" data-mp="1umdcblqf4jar"></span>
            My Personal Investment
          </h2>
          <p className="mb-5 text-base" data-id="element-378" data-mp="1ku7omo778o1d">
            At 58, with three decades of medical experience, I've learned to be
            selective about what I endorse.
          </p>
          <p className="mb-5 text-base" data-id="element-379" data-mp="16x2lox2s85ac">
            I now own five BareEarth sheets – one for each bedroom plus two
            spares.
          </p>
          <p className="mb-5 text-base" data-id="element-380" data-mp="wxlj4oitu7il">
            Not because Tom gave them to me (I insisted on paying full price).
          </p>
          <p className="mb-5 text-base" data-id="element-381" data-mp="11vvasp5cepzg">
            But because after 12 months of rigorous testing, they're the only
            sheets still working.
          </p>
          <p className="mb-6 text-base bg-yellow-100 p-2" data-id="element-382" data-mp="2w8l8zj2qulcn">
            My sleep scores stay consistent. My back pain stays manageable. My
            inflammation markers stay reduced.
          </p>
          <p className="mb-6 text-base" data-id="element-383" data-mp="10j4019dpvt2f">
            All from sheets that actually keep grounding, month after month,
            year after year.
          </p>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-384" data-mp="rjgzepstaraf">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-385" data-mp="cti18n19bfuy"></span>
            How to Access Tom's Offer
          </h2>
          <p className="mb-5 text-base" data-id="element-386" data-mp="hmufq4c8269z">
            Tom created a special page exclusively for readers of this
            investigation:
          </p>
          <div className="text-center my-10" data-id="element-387" data-mp="8sfyvxc1mnor">
            <div className="max-w-md mx-auto" data-id="element-388" data-mp="8t7jye80l30s">
              <CTAButton data-id="element-389" data-mp="3q1cmm2qfffs0" />
            </div>
          </div>
          <p className="mb-5 text-base bg-yellow-100 p-2" data-id="element-390" data-mp="3q1urtov2h4c2">
            The offer expires 72 hours after this article publishes. Current
            inventory is approximately 200 sheets before the next production run
            in 3-4 weeks.
          </p>
          <p className="mb-6 text-base" data-id="element-391" data-mp="37dkf20kdcauy">
            Every order includes a multimeter. Tom wants you to test it
            yourself.
          </p>
          <p className="mb-6 text-base" data-id="element-392" data-mp="3lah1zqxd986k">
            That's the confidence that comes from actual engineering, not
            marketing claims.
          </p>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-393" data-mp="3uc6u6yz2ob5e">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-394" data-mp="3qbeky5q7a694"></span>A
            Final Thought from Tom
          </h2>
          <p className="mb-5 text-base" data-id="element-395" data-mp="2ykiy549tw21">
            When I asked Tom why he does this at 72, his answer stayed with me:
          </p>
          <blockquote className="font-serif italic border-l-3 border-gray-400 pl-5 py-4 my-8 bg-yellow-50 rounded-r text-gray-700" data-id="element-396" data-mp="hwwgsf3draus">
            "I found something that genuinely helped my pain after decades of
            suffering. Then I discovered an entire industry scamming people with
            products designed to fail. I had the knowledge to fix it. What kind
            of engineer – what kind of person – would I be if I didn't?"
            <div className="text-sm mt-3 text-gray-600 not-italic" data-id="element-397" data-mp="tw1jaf8u4mxr">
              — Tom Davidson, Electrical Engineer
            </div>
          </blockquote>
          <div className="border-t border-gray-200 mt-12 pt-6" data-id="element-398" data-mp="13mw7hp5n5wlu">
            <div className="flex items-center mb-4" data-id="element-399" data-mp="17p99c2h9padc">
              <div className="w-8 h-8 overflow-hidden rounded-full flex-shrink-0 mr-2 border border-gray-300" data-id="element-400" data-mp="17ny7473h0aoc">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/5V1KLd9diP6p4Lsag55oX2/YYkJmGMhE_ELwA2hWH_Ii.jpg" alt="Patricia Chen" className="w-full h-full object-cover" data-id="element-401" data-mp="1cmj848qjqydu" />
              </div>
              <p className="text-sm text-gray-800" data-id="element-402" data-mp="3jfv5vdqmoksl">
                <span className="font-medium" data-id="element-403" data-mp="3bvkl1ex71xla">Patricia Chen, RN, MSN.</span>{' '}
                This investigation was entirely self-funded with no compensation
                from any mentioned company.
              </p>
            </div>
            <p className="text-sm text-gray-700 mb-3 bg-yellow-100 p-2 border-l-2 border-yellow-500" data-id="element-404" data-mp="326j3vlewxa5q">
              <strong data-id="element-405" data-mp="2x7zetc50vi95">P.S.</strong> – If you currently own a grounding sheet,
              test it with a multimeter today. If it reads over 500 ohms, it's
              dead. That's why your benefits disappeared – not because your body
              "adapted," but because your sheet stopped working.
            </p>
            <p className="text-sm text-gray-700 bg-yellow-100 p-2 border-l-2 border-yellow-500" data-id="element-406" data-mp="3kuebenjxlrqe">
              <strong data-id="element-407" data-mp="3fwwb1ljzcku0">P.P.S.</strong> – Tom Davidson personally responds to
              every email. When's the last time you could reach a founder
              directly? That tells you everything about the integrity behind
              this product.
            </p>
          </div>
        </div>
      </main>
      <div className="px-4 sm:px-8 py-6 border-t border-gray-200 bg-gray-50" data-id="element-408" data-mp="3ta3l7rtxp12h">
        <div className="max-w-4xl mx-auto text-[10px] text-gray-400 leading-tight" data-id="element-409" data-mp="1z25744xe3nw">
          <p className="mb-2" data-id="element-410" data-mp="3jf1vouvqxwzd">
            These statements have not been evaluated by the Food and Drug
            Administration. This product is not intended to diagnose, treat,
            cure, or prevent any disease.
          </p>
          <p className="mb-2" data-id="element-411" data-mp="fv77gepv6no0">
            Individual results may vary. Results described in testimonials and
            case studies are not typical and your experience may differ.
          </p>
          <p className="mb-2" data-id="element-412" data-mp="616vbsw60i5s">
            This article is for informational purposes only and is not intended
            as a substitute for advice from your physician or other healthcare
            professional.
          </p>
          <p className="mb-2" data-id="element-413" data-mp="2vo6aiglsq013">
            Any references to scientific studies, researchers, or institutions
            are for informational context only and do not imply endorsement of
            this product.
          </p>
          <p data-id="element-414" data-mp="18qn960fjkygv">
            This is a paid advertisement for BareEarth and is not an actual news
            article or blog. The story and opinions expressed here are for
            promotional purposes only.
          </p>
        </div>
      </div>
      <div className="bg-black h-3 w-full" data-id="element-415" data-mp="1io1o1vlthf72"></div>
    </div>;
};
export default Advertorial;